import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
	ChangeDetectorRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, finalize, map, noop, of, Subscription, tap } from 'rxjs';
import { Utils } from 'formiojs';
import _cloneDeep from 'lodash/cloneDeep';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { KeycloakService } from 'keycloak-angular';
import { FormioLoader, STEPPERTABSTATUS, ResourceNameService, UserService, CUSTOMFORMACTIONS, SuccessToast, ErrorToast } from 'dp-formio';

@Component({
	selector: 'lib-stepper-wrapper',
	templateUrl: './stepper-wrapper.component.html',
	// styleUrls: ['./stepper-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [FormioLoader],
})
export class StepperWrapperComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
	@ViewChild('form') form: any;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();

	dir: 'rtl' | 'ltr';
	@Output() formSubmitted = new EventEmitter<any>();
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;
	stepperMenu: {
		formSubmissionId?;
		formKey?;
		submit?;
		submitted?;
		order?;
		formiokey?;
		summarySubmissionId?;
		status?;
	}[] = [];
	messageInfo: { [k: string]: any } = {};
	summaryResourceKey: string;
	historySummaryResourceKey: string;
	resource = '';
	query = '';
	formSubmission: any;
	summaryFormSubmission: any;
	activeStep: number = 0;
	currentForm: any;
	formReady = false;
	decisionsFormSubmission: any = {};
	decisionsFormReady = false;
	isRequirmentsFormReadOnly = false;
	isFOView: boolean;
	isBOView: boolean;
	parentRoute: string;
	parentTaskId: string;
	isNestedStepper: boolean;
	isLoggedIn = false;

	public get TABSTATUS(): typeof STEPPERTABSTATUS {
		return STEPPERTABSTATUS;
	}

	subscriptions$: Subscription[] = [];
	set sub(s: Subscription) {
		this.subscriptions$.push(s);
	}

	constructor(
		private translateService: TranslateService,
		private resourceNameService: ResourceNameService,
		private toastrService: ToastrService,
		public formioLoader: FormioLoader,
		private userService: UserService,
		private keycloak: KeycloakService,
		private route: ActivatedRoute,
		private location: Location,
		private cdRef: ChangeDetectorRef
	) {
		this.changeDirection(this.translateService.currentLang);
	}

	ngAfterViewInit(): void {
		this.sub = this.translateService.onLangChange.subscribe((data) => {
			this.changeDirection(data.lang);
		});
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang == 'ar' ? 'rtl' : 'ltr';
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.customOptions) {
			this.messageInfo = this.customOptions.messageInfo;

			this.summaryResourceKey = this.customOptions.summaryResourceKey;
			this.historySummaryResourceKey = this.customOptions.historySummaryResourceKey;
			this.isNestedStepper = this.customOptions.isNestedStepper;
			this.isFOView = this.data?.isFOView;
			this.isBOView = this.data?.isBOView;

			if (this.customOptions.stepperData) {
				if (
					changes &&
					changes.data &&
					changes.data.currentValue &&
					changes.data.currentValue.stepperWrapper &&
					changes.data.currentValue.stepperWrapper.stepper &&
					changes.data.currentValue.stepperWrapper.stepper.length &&
					!this.isNestedStepper
				) {
					this.stepperMenu = Utils.evaluate(this.customOptions.stepperData, {
						data: this.data.stepperWrapper.stepper,
					});
					this.loadSubStepper(() => {
						this.activeStep = this.data.activeStepIndex || 0;
						this.currentForm = this.stepperMenu[this.activeStep];

						this.data.activeTab = { data: { ...this.currentForm } };
						this.data.activeStepIndex = this.activeStep;

						this.getSubmissions();
					});
				}
			} else if (this.customOptions.resource || this.customOptions.query) {
				this.resource = this.formioComponent.interpolate(this.customOptions.resource, {
					data: this.data,
				});
				this.query = this.formioComponent.interpolate(this.customOptions.query, {
					data: this.data,
				});
				this.getStepperData();
			}
		}
	}

	private loadSubStepper(callback) {
		if (this.customOptions.subStepper) {
			if (this.data.subStepper) callback();

			this.resource = this.formioComponent.interpolate(this.customOptions.subStepper.resource, {
				data: this.data,
			});
			this.query = this.formioComponent.interpolate(this.customOptions.subStepper.query, {
				data: this.data,
			});
			this.loadStepperData(() => callback());
		} else callback();
	}

	loadStepperData(callback) {
		this.formioLoader.loading = true;
		this.sub = this.resourceNameService
			.loadCustomByFilterdKey(this.resource, this.query)
			.pipe(
				map((res: any[]) =>
					res.map((elem) => {
						return { summarySubmissionId: elem._id, ...elem.data };
					})
				)
			)
			.subscribe(
				(data) => {
					this.data.subStepper = data;
					this.formioLoader.loading = false;
					this.updateRootIfExist();
					callback();
				},
				(error) => {
					this.formioLoader.loading = false;
					throw error;
				}
			);
	}

	private updateRootIfExist() {
		this.formioComponent?.root.components
			?.filter((q) => q.type == 'form')
			?.forEach((form) => {
				form.subForm.components.forEach((c) => {
					c.calculateValue();
				});
			});
	}

	async ngOnInit() {
		const queryParams: string[] = this.route.snapshot.queryParamMap.keys;
		if (queryParams.length) {
			if (this.route.snapshot.queryParamMap.has('parentRoute')) {
				this.parentRoute = this.route.snapshot.queryParamMap.get('parentRoute');

				this.parentTaskId = this.route.snapshot.queryParamMap.get('taskId');

				this.decisionsFormSubmission.parentRoute =
					this.route.snapshot.queryParamMap.get('parentRoute');

				try {
					this.isLoggedIn = await this.keycloak.isLoggedIn();
					const userData = await this.userService.getUserData(
						this.isLoggedIn ? await this.keycloak.getToken() : null
					);
					this.decisionsFormSubmission.userName = userData?.user_preferred_username;
					this.decisionsFormSubmission.fullName = userData?.user_name;
					this.decisionsFormSubmission.userData = userData;
				} catch (error) {
					console.log(error);
				}
			} else {
				this.location.back();
			}
		} else {
			this.location.back();
		}
	}

	getStepperData() {
		this.formioLoader.loading = true;
		this.sub = this.resourceNameService
			.loadCustomByFilterdKey(this.resource, this.query)
			.pipe(
				map((res: any[]) =>
					res.map((elem) => {
						return { summarySubmissionId: elem._id, ...elem.data };
					})
				)
			)
			.subscribe(
				(data) => {
					this.stepperMenu = [...data];
					this.currentForm = this.stepperMenu[this.activeStep];
					this.notifyValue();
					this.formioLoader.loading = false;
				},
				(error) => {
					this.formioLoader.loading = false;
					throw error;
				},
				() => {
					this.getSubmissions();
				}
			);
	}

	getSubmissions() {
		this.resourceNameService
			.loadCustomByKeyId(this.currentForm.formKey, this.currentForm.formSubmissionId)
			.pipe(
				tap((res: any) => {
					if (res && res.data) {
						this.formSubmission = {
							data: {
								...res.data,
								...this.data,
								parentRoute: this.parentRoute,
							},
						};
					}
				}),
				finalize(() => {
					setTimeout(() => {
						window.scrollTo({
							top: 0,
							left: 0,
							behavior: 'smooth',
						});
					});

					// this.isNestedStepper ? (this.formReady = true) : (this.decisionsFormReady = true);
					this.formReady = true;
					setTimeout(() => {
						this.decisionsFormReady = true;
					});
				}),
				catchError((error) => {
					this.formioLoader.loading = false;
					this.decisionsFormReady = false;
					return of(0);
				})
			)
			.subscribe();
	}

	notifyValue() {
		this.value = {
			nestedStepperData: [...this.stepperMenu],
		};
		this.valueChange.emit(this.value);
	}

	formLoad(evnet) {
		setTimeout(() => {
			if (!this.isNestedStepper) {
				this.form?.formio?.off('stepSubmited');
				this.form?.formio?.on('stepSubmited', (formKey) => {
					this.data.subStepper.find((q) => q.formKey == formKey).submitted = true;

					this.customOptions.notifyCalculatedFileds?.forEach((key) => {
						const components = Utils.searchComponents(this.formioComponent.root.components, {
							key: key,
						});
						components.forEach((c) => {
							c.calculateValue();
						});
						const nestedForms = Utils.searchComponents(this.formioComponent.root.components, {
							type: 'form',
						});
						nestedForms.forEach((formComponent) => {
							formComponent.subFormReady.then((subForm) => {
								const components = Utils.searchComponents(subForm.components, { key: key });
								components.forEach((c) => {
									c.calculateValue();
								});
							});
						});
					});
				});

				this.form?.formio?.off('notifyParentStepper');
				this.form?.formio?.on('notifyParentStepper', () => {
					this.changeParentTabSubmittedFlag();
				});
			}
		});
	}

	onLoadDecisions(event) {
		if (this.formSubmission.data) {
			this.data.decisionsSubmission = event.data;
			this.formSubmission.data.decisionsSubmission = event.data;
			if (this.form?.submission?.data)
				this.form.submission.data.decisionsSubmission = event.data;
			this.form?.formio?.setSubmission(this.formSubmission);
			this.valueChange.emit(this.value);
		}
	}

	onSelectStep(index: number, form: any, isSideItem = false) {
		if (this.activeStep === index && isSideItem) {
			return;
		}

		this.data.activeTab = { data: { ...form } };
		this.data.activeStepIndex = index;
		this.formioComponent.currentForm.triggerChange();

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});

		this.currentForm = null;
		this.formReady = false;
		this.decisionsFormReady = false;
		setTimeout(() => {
			this.currentForm = form;
			if (this.isNestedStepper) {
				this.getSubmissions();
			}
		});
		this.activeStep = index;
	}

	customSave(event) {
		const eventData = _cloneDeep(event);

		const formKeys = Utils.searchComponents(this.form.formio.components, {
			'component.input': true,
		}).map((q) => q.component.key);

		for (let prop in eventData.data) {
			if (!formKeys.includes(prop)) {
				delete eventData.data[prop];
			}
		}

		//this block for buttons scope
		if (eventData?.component?.properties?.effectedTab) {
			eventData.component.properties.effectedTab.split(',').forEach((index) => {
				this.stepperMenu[index].submitted = false;
			});
		}
		if (eventData?.component?.properties?.callsWhenEffectedTab) {
			this.form.makeCalls(this.form.form, null, JSON.parse(eventData.component.properties.callsWhenEffectedTab), [], []);
		}

		//this block for form scope
		if (this.form?.form?.properties?.effectedTabKeys) {
			const formsKeys = JSON.parse(this.form.form.properties.effectedTabKeys);
			formsKeys.forEach((item) => {
				if (Utils.evaluate(item.conditional, { data: eventData.data }))
					this.stepperMenu.find(q => q.formKey == item.key).submitted = false;
			});
		}
		if (this.form?.form?.properties?.callsWhenEffectedTab) {
			this.form.makeCalls(this.form.form, null, JSON.parse(this.form.form.properties.callsWhenEffectedTab), [], []);
		}

		switch (eventData.type) {
			case CUSTOMFORMACTIONS.SAVE:
				this.checkFormValidation(eventData.data);
				break;

			case CUSTOMFORMACTIONS.SAVEDRAFT:
				this.onSaveData(eventData.data, true);
				break;
		}
	}

	checkFormValidation(data: any) {
		if (!this.form.formio.checkValidity(this.form.formio.data, true)) {
			this.form.onError(this.form.formio.errors);
			return;
		}

		this.onSaveData(data);
	}

	onSaveData(formData: any, saveDraft = false) {
		this.formioLoader.loading = true;

		const body: any = {
			data: {
				...formData,
			},
		};

		saveDraft ? (body.state = 'draft') : noop();

		let isDataSaved = false;

		this.sub = this.resourceNameService
			.editSubmission(this.currentForm.formKey, this.currentForm.formSubmissionId, {
				...body,
			})
			.pipe(
				tap((res) => {
					if (res && res.data) {
						isDataSaved = true;
						this.toastrService.show(this.translateService.instant('Saved Message'), '', {
							toastClass: 'notification-toast',
							closeButton: true,
							enableHtml: true,
							toastComponent: SuccessToast,
						});

						if (!saveDraft && this.isNestedStepper) {
							this.formioComponent.root.emit('stepSubmited', this.currentForm.formKey);
						}
					}
				}),
				finalize(() => {
					if (isDataSaved && !saveDraft) {
						this.changeTabSubmittedFlag(saveDraft);
					} else if (isDataSaved && saveDraft) {
						if (this.currentForm.submitted && !this.form.formio.isValid()) {
							this.changeTabSubmittedFlag(saveDraft);
						} else {
							this.formioLoader.loading = false;
						}
					}
				}),
				catchError((error) => {
					this.formioLoader.loading = false;
					return of(0);
				})
			)
			.subscribe();
	}

	changeTabSubmittedFlag(saveDraft: boolean) {
		this.resourceNameService
			.patchSubmission(this.summaryResourceKey, this.currentForm.summarySubmissionId, [
				{
					op: 'add',
					path: '/data/submitted',
					value: !saveDraft ? true : false,
				},
			])
			.pipe(
				tap((res) => {
					if (res && res.data) {
						this.changeTabColor(saveDraft);
					}
				}),
				finalize(() => {
					this.formioLoader.loading = false;
				})
			)
			.subscribe();
	}

	changeParentTabSubmittedFlag() {
		this.resourceNameService
			.patchSubmission(this.summaryResourceKey, this.currentForm.summarySubmissionId, [
				{
					op: 'add',
					path: '/data/submitted',
					value: false,
				},
			])
			.pipe(
				tap((res) => {
					if (res && res.data) {
						this.data.stepperWrapper.stepper.map((item: any) => {
							if (item.formKey === this.currentForm.formKey) {
								item.submitted = false;
							}
						});
					}
				}),
				finalize(() => {
					this.formioLoader.loading = false;
				})
			)
			.subscribe();
	}

	afterDecisionSubmitted(event) {
		if (event && event.submission && event.submission.data) {
			if (this.customOptions.saveSummaryToHisotryResource) {
				this.saveDecisionToHistoryResource({
					...event.submission.data,
					submissionId: event.submission._id,
				});
			} else {
				this.formioLoader.loading = false;
				this.changeTabColor(false, true, event.submission.data);
			}
		}
	}

	async saveDecisionToHistoryResource(data) {
		this.formioLoader.loading = true;

		if (this.parentTaskId != data.taskId) {
			const body = {
				...data,
				taskId: this.parentTaskId,
			};

			// To Create New Record in History Summary Resource
			const historyItem: any = await this.addOrEditSummary(
				null,
				body,
				this.historySummaryResourceKey
			);

			// To Update Record in Parent Summmary Resource
			await this.addOrEditSummary(
				data.submissionId,
				{ ...body, historySummaryId: historyItem._id },
				this.summaryResourceKey
			);

			this.formioLoader.loading = false;
			this.changeTabColor(false, true, data);
		} else {
			// In case of parent tasId is equal to current summary taskId

			let historySummaryItem: any;
			const query = `_id=${data.historySummaryId}`;
			this.resourceNameService
				.loadCustomByFilterdKey(this.historySummaryResourceKey, query)
				.subscribe(
					(res: any[]) => {
						if (res && res.length) {
							historySummaryItem = res[0];
						}
					},
					() => {
						this.formioLoader.loading = false;
						this.changeTabColor(false, true, data);
					},
					async () => {
						// To Create New Record in History Summary Resource
						await this.addOrEditSummary(
							historySummaryItem._id,
							data,
							this.historySummaryResourceKey
						);

						this.formioLoader.loading = false;
						this.changeTabColor(false, true, data);
					}
				);
		}
	}

	addOrEditSummary(submissionId: string, obj, resource: string): Promise<string> {
		return new Promise(async (resolve, reject) => {
			try {
				let result: any;
				if (submissionId) {
					result = await this.resourceNameService
						.editSubmission(resource, submissionId, { data: obj })
						.toPromise();
				} else {
					result = await this.resourceNameService
						.addSubmission(resource, { data: obj })
						.toPromise();
				}
				resolve(result);
			} catch (e) {
				this.toastrService.show(
					this.translateService.instant('History not saved!'),
					this.translateService.instant('ErrorOccurred'),
					{
						toastClass: 'notification-toast',
						closeButton: true,
						enableHtml: true,
						toastComponent: ErrorToast,
					}
				);
				this.formioLoader.loading = false;
				reject(e);
			}
		});
	}

	changeTabColor(saveDraft, isDecisionForm = false, decisionSubmission: any = {}) {
		if (!this.isNestedStepper) {
			this.data.stepperWrapper.stepper.map((item: any) => {
				if (item.formKey === this.currentForm.formKey) {
					isDecisionForm
						? (item.status = decisionSubmission.status)
						: (item.submitted = !saveDraft ? true : false);
				}
			});
		} else {
			this.stepperMenu.map((item: any) => {
				if (item.formKey === this.currentForm.formKey) {
					item.submitted = !saveDraft ? true : false;
				}
			});

			const isAllStepsSubmitted = this.stepperMenu.every((step: any) => step.submitted);
			if (!isAllStepsSubmitted && saveDraft) {
				this.formioComponent.root.emit('notifyParentStepper', null);
			}
		}
		this.cdRef.detectChanges();
		this.formioComponent.currentForm.triggerChange();

		if (!saveDraft) {
			this.moveToNextStep();
		}
	}

	moveToNextStep() {
		const index =
			this.activeStep < this.stepperMenu.length - 1
				? this.activeStep + 1
				: this.stepperMenu.length - 1;

		const form = this.stepperMenu[index];

		this.onSelectStep(index, form, index === this.stepperMenu.length - 1 ? true : false);
	}

	ngOnDestroy() {
		this.subscriptions$.forEach((o) => o.unsubscribe());
		this.subscriptions$ = [];
	}
}
